
import { defineComponent } from 'vue'
import debounce from 'lodash/debounce'

export default defineComponent({
  name: 'Search',
  emits: ['inputChanged'],
  props: {
    placeholder: {
      type: String
    },
    debounce: {
      type: Number,
      default: 200
    },
    value: String
  },
  setup(props, { emit }) {
    const emitValue = debounce(function (value: KeyboardEvent) {
      const input = value || ''
      return emit('inputChanged', input)
    }, props.debounce)

    return {
      emitValue
    }
  }
})
